import React from "react";
import { resetApiCache } from "../../services/api/resetApiCache";
import { LOGGED_IN_USER_UPDATED } from "../../constants/sessionEvents";
import { useNavigate } from "react-router-dom";
const LogoutModal = ({ setShowLogoutModal }) => {
  const navigate = useNavigate();
  const handleLogout = () => {
    localStorage.removeItem("loggedInUser");
    window.dispatchEvent(new Event(LOGGED_IN_USER_UPDATED));
    resetApiCache();
    setShowLogoutModal(false);
    navigate("/login");
  };
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 px-4">
      <div className="font-['Roboto'] w-full max-w-[420px] rounded-2xl bg-white px-8 py-10 shadow-2xl">
        <h2 className="text-center text-2xl font-medium text-[#1D2026]">
          Logout of your Account
        </h2>

        <div className="mt-6 flex items-center justify-center gap-3">
          <button
            type="button"
            onClick={() => setShowLogoutModal(false)}
            className="h-10  rounded-xl border border-[#000] px-6 text-lg font-medium text-[#1D2026]"
          >
            Cancel
          </button>
          <button
            type="button"
            onClick={handleLogout}
            className="h-10  rounded-xl bg-[#FF6636] px-6 text-lg font-medium text-white"
          >
            Logout
          </button>
        </div>
      </div>
    </div>
  );
};

export default LogoutModal;
